export const catColors = [
  {
    name: "Mac & Cheese",
    primary: "#FFAE7B",
    secondary: "#754F44",
    type: "light",
  },
  { name: "Brandy", primary: "#5F464B", secondary: "#8E4A49", type: "dark" },
  {
    name: "Deep Purple",
    primary: "#22162B",
    secondary: "#451F55",
    type: "dark",
  },
  { name: "Coral", primary: "#F87575", secondary: "#ffa9a3", type: "light" },
  { name: "Jet", primary: "#302b27", secondary: "#F5F3F5", type: "dark" },
  { name: "Sunburn", primary: "#ff5e5b", secondary: "#00cecb", type: "light" },
  { name: "Unburn", primary: "#00cecb", secondary: "#ff5e5b", type: "light" },
  { name: "Half Life", primary: "#ef8354", secondary: "#000", type: "light" },
  { name: "Purply", primary: "#7251b5", secondary: "#000", type: "light" },
];

export const backgroundColors = [
  { name: "Undergrowth", primary: "#1D655C", secondary: "#2A9D8F" },
  { name: "Blue Space", primary: "#1B264F", secondary: "#274690" },
  { name: "Reddy", primary: "#BA1B1D", secondary: "#F24333" },
  { name: "Fresh Powder", primary: "#A8DADC", secondary: "#F1FAEE" },
  { name: "Slippery Salmon", primary: "#FF8E72", secondary: "#FFAF87" },
  { name: "Black and Brown", primary: "#080705", secondary: "#362023" },
  { name: "Dark Forest", primary: "#003B36", secondary: "#012622" },
  { name: "Join the Navy", primary: "#023E8A", secondary: "#03045E" },
  { name: "Let them eat cake", primary: "#7B4997", secondary: "#ffafcc" },
];
